/**
 * Whether an ACTIVE Schedule Meet still has an occurrence overlapping today
 * that has not fully ended yet.
 */
export const isScheduleMeetRemainingToday = (
  meet: {
    status: string;
    startAt: string;
    nextSessionStartAt?: string | null;
    durationMinutes?: number | null;
  },
  now: Date = new Date()
): boolean => {
  if (meet.status !== 'ACTIVE') return false;

  const start = new Date(meet.nextSessionStartAt || meet.startAt);
  if (Number.isNaN(start.getTime())) return false;

  const durationMinutes = meet.durationMinutes || 60;
  const end = new Date(start.getTime() + durationMinutes * 60 * 1000);
  if (end.getTime() < now.getTime()) return false;

  const dayStart = new Date(now);
  dayStart.setHours(0, 0, 0, 0);
  const dayEnd = new Date(now);
  dayEnd.setHours(23, 59, 59, 999);

  return (
    start.getTime() <= dayEnd.getTime() && end.getTime() >= dayStart.getTime()
  );
};
